<script>
import Vue from 'vue';
import store from '../../store';
import Alert from '../Alert/Alert.vue';
import Loading from '../Loading/Loading.vue';
import InfoWidget from '../InfoWidget/InfoWidget.vue';
import Instruction from '../Instruction/Instruction.vue';
import ContractListOverview from '../ContractListOverview/ContractListOverview.vue';
import {mapState, mapActions} from 'vuex';

export default Vue.extend({
    components: {
        Alert,
        Loading,
        InfoWidget,
        Instruction,
        ContractListOverview
    },
    computed: {
        ...mapState({
            supplier: state => state.auth.supplier
        })
    },
    watch: {
        supplier: (supplier) => {
            store.dispatch('contract/getContractHistoryBySupplierId', supplier.id);
        }
    },
    created () {
        const supplierId = this.supplier.id;
        this.getContractHistoryBySupplierId(supplierId);
    },
    methods: {
        ...mapActions({
            getContractHistoryBySupplierId: 'contract/getContractHistoryBySupplierId'
        })
    }
});
</script>
<template>
    <div class="contract-list-page">
        <div class="contract-list-page__content">
            <instruction :page="'contractList'"/>
            <contract-list-overview/>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractListPage/ContractListPage.vue